/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PromoTokenType } from './PromoTokenType';
import {
    PromoTokenTypeFromJSON,
    PromoTokenTypeFromJSONTyped,
    PromoTokenTypeToJSON,
    PromoTokenTypeToJSONTyped,
} from './PromoTokenType';

/**
 * Represents a single promo token reward.
 * @export
 * @interface PromoToken
 */
export interface PromoToken {
    /**
     * 
     * @type {string}
     * @memberof PromoToken
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof PromoToken
     */
    createdAt: number;
    /**
     * 
     * @type {number}
     * @memberof PromoToken
     */
    updatedAt: number;
    /**
     * 
     * @type {string}
     * @memberof PromoToken
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof PromoToken
     */
    description?: string;
    /**
     * 
     * @type {PromoTokenType}
     * @memberof PromoToken
     */
    type: PromoTokenType;
    /**
     * 
     * @type {string}
     * @memberof PromoToken
     */
    targetUrl?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PromoToken
     */
    isEnabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PromoToken
     */
    isBranded?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof PromoToken
     */
    couponCodes?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof PromoToken
     */
    qrImageUrl?: string;
    /**
     * 
     * @type {number}
     * @memberof PromoToken
     */
    expiresAt?: number;
    /**
     * 
     * @type {number}
     * @memberof PromoToken
     */
    maxLimit?: number;
    /**
     * 
     * @type {string}
     * @memberof PromoToken
     */
    apiEndpoint?: string;
    /**
     * 
     * @type {string}
     * @memberof PromoToken
     */
    apiKeyRef?: string;
    /**
     * 
     * @type {object}
     * @memberof PromoToken
     */
    apiPayloadTemplate?: object;
    /**
     * 
     * @type {string}
     * @memberof PromoToken
     */
    loyaltyPartnerId?: string;
    /**
     * 
     * @type {number}
     * @memberof PromoToken
     */
    pointsToAward?: number;
    /**
     * 
     * @type {string}
     * @memberof PromoToken
     */
    loyaltyApiEndpoint?: string;
    /**
     * 
     * @type {string}
     * @memberof PromoToken
     */
    loyaltyApiKeyRef?: string;
    /**
     * 
     * @type {string}
     * @memberof PromoToken
     */
    requiredLinkedAccount?: string;
    /**
     * 
     * @type {string}
     * @memberof PromoToken
     */
    discountMerchantId?: string;
    /**
     * 
     * @type {number}
     * @memberof PromoToken
     */
    discountPercentage?: number;
    /**
     * 
     * @type {string}
     * @memberof PromoToken
     */
    redemptionRewardConfigId?: string;
}



/**
 * Check if a given object implements the PromoToken interface.
 */
export function instanceOfPromoToken(value: object): value is PromoToken {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('isEnabled' in value) || value['isEnabled'] === undefined) return false;
    return true;
}

export function PromoTokenFromJSON(json: any): PromoToken {
    return PromoTokenFromJSONTyped(json, false);
}

export function PromoTokenFromJSONTyped(json: any, ignoreDiscriminator: boolean): PromoToken {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'type': PromoTokenTypeFromJSON(json['type']),
        'targetUrl': json['targetUrl'] == null ? undefined : json['targetUrl'],
        'isEnabled': json['isEnabled'],
        'isBranded': json['isBranded'] == null ? undefined : json['isBranded'],
        'couponCodes': json['couponCodes'] == null ? undefined : json['couponCodes'],
        'qrImageUrl': json['qrImageUrl'] == null ? undefined : json['qrImageUrl'],
        'expiresAt': json['expiresAt'] == null ? undefined : json['expiresAt'],
        'maxLimit': json['maxLimit'] == null ? undefined : json['maxLimit'],
        'apiEndpoint': json['apiEndpoint'] == null ? undefined : json['apiEndpoint'],
        'apiKeyRef': json['apiKeyRef'] == null ? undefined : json['apiKeyRef'],
        'apiPayloadTemplate': json['apiPayloadTemplate'] == null ? undefined : json['apiPayloadTemplate'],
        'loyaltyPartnerId': json['loyaltyPartnerId'] == null ? undefined : json['loyaltyPartnerId'],
        'pointsToAward': json['pointsToAward'] == null ? undefined : json['pointsToAward'],
        'loyaltyApiEndpoint': json['loyaltyApiEndpoint'] == null ? undefined : json['loyaltyApiEndpoint'],
        'loyaltyApiKeyRef': json['loyaltyApiKeyRef'] == null ? undefined : json['loyaltyApiKeyRef'],
        'requiredLinkedAccount': json['requiredLinkedAccount'] == null ? undefined : json['requiredLinkedAccount'],
        'discountMerchantId': json['discountMerchantId'] == null ? undefined : json['discountMerchantId'],
        'discountPercentage': json['discountPercentage'] == null ? undefined : json['discountPercentage'],
        'redemptionRewardConfigId': json['redemptionRewardConfigId'] == null ? undefined : json['redemptionRewardConfigId'],
    };
}

export function PromoTokenToJSON(json: any): PromoToken {
    return PromoTokenToJSONTyped(json, false);
}

export function PromoTokenToJSONTyped(value?: PromoToken | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
        'name': value['name'],
        'description': value['description'],
        'type': PromoTokenTypeToJSON(value['type']),
        'targetUrl': value['targetUrl'],
        'isEnabled': value['isEnabled'],
        'isBranded': value['isBranded'],
        'couponCodes': value['couponCodes'],
        'qrImageUrl': value['qrImageUrl'],
        'expiresAt': value['expiresAt'],
        'maxLimit': value['maxLimit'],
        'apiEndpoint': value['apiEndpoint'],
        'apiKeyRef': value['apiKeyRef'],
        'apiPayloadTemplate': value['apiPayloadTemplate'],
        'loyaltyPartnerId': value['loyaltyPartnerId'],
        'pointsToAward': value['pointsToAward'],
        'loyaltyApiEndpoint': value['loyaltyApiEndpoint'],
        'loyaltyApiKeyRef': value['loyaltyApiKeyRef'],
        'requiredLinkedAccount': value['requiredLinkedAccount'],
        'discountMerchantId': value['discountMerchantId'],
        'discountPercentage': value['discountPercentage'],
        'redemptionRewardConfigId': value['redemptionRewardConfigId'],
    };
}

